import { Copyright, Links, Wrapper } from './footer.styles';

import ContactUsLink from './contact_us_link';
import PrivacyPolicyDialog from './privacy_policy_dialog';
import PrivacyPolicyLink from './privacy_policy_link';
import TermsAndConditionsDialog from './terms_and_conditions_dialog';
import TermsAndConditionsLink from './terms_and_conditions_link';

const COPYRIGHT_START_YEAR = 2024;

const currentYear = new Date().getFullYear();
const copyrightYear =
  currentYear === COPYRIGHT_START_YEAR
    ? COPYRIGHT_START_YEAR
    : `${COPYRIGHT_START_YEAR}–${currentYear}`;

export default function Footer() {
  return (
    <>
      <Wrapper>
        <Links>
          <TermsAndConditionsLink />
          <PrivacyPolicyLink />
          <ContactUsLink />
        </Links>
        <Copyright>{`© Salad Story S.A. ${copyrightYear}`}</Copyright>
      </Wrapper>
      <TermsAndConditionsDialog />
      <PrivacyPolicyDialog />
    </>
  );
}
